import styled from "styled-components";
import { Title } from "../ApplicationSection/styled";

export const GraySection = styled.div`
  width: 100%;
  background-color: #f0f0f0;
  height: 220px;
  display: block;
  /* margin-left: -3%; */
  padding-top: 20px;

  /* @media only screen and (max-width: 1250px) {
  width: 100vw;
  margin-left: -2,5%;
} */
  @media only screen and (max-width: 768px) {
    margin: 0;
  }
`;

export const Title1 = styled(Title)`
  font-size: 32px;
  letter-spacing: 0.5px;

  & > span {
    background-image: linear-gradient(#f0f0f0 35%, rgba(255, 255, 255, 1) 0%);
    display: inline;
    background-position: right 0px bottom 0px;
    padding: 0px 18px;
  }

  @media only screen and (max-width: 560px) {
    font-size: 24px;
    word-spacing: -3px;
  }
`;

export const InfoText = styled.p`
  text-align: center;
  font-size: 18px;
  color: black;
  font-family: "Helvetica";
  /* font-weight: bolder; */
  line-height: 12px;

  @media only screen and (max-width: 560px) {
    line-height: normal;
    margin-bottom: 0px;
  }

  &:first-of-type {
    padding-top: 5%;
  }
`;
